import React from "react";
import { shape, func, bool, string } from "prop-types";
import { Link } from "@quintype/components";

const MenuItem = ({ item, itemClick, isSelected = false, isHeaderMenu = false }) => {
  if (item["item-type"] === "placeholder") {
    return <span className={isSelected ? "menu-selected-item" : ""}>{item.title}</span>;
  } else if (item["item-type"] === "link") {
    return (
      <a
        href={item.completeUrl}
        rel="noopener noreferrer"
        onClick={itemClick}
        className={
          isSelected && isHeaderMenu
            ? "menu-selected-item header-menu-selected-item"
            : "" || isSelected
            ? "menu-selected-item"
            : ""
        }
      >
        {item.title}
      </a>
    );
  } else {
    return (
      <Link
        href={item.completeUrl}
        rel="noopener noreferrer"
        callback={itemClick}
        className={
          isSelected && isHeaderMenu
            ? "menu-selected-item header-menu-selected-item"
            : "" || isSelected
            ? "menu-selected-item"
            : ""
        }
      >
        {item.title}
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: shape({
    isExternalLink: bool,
    completeUrl: string,
    title: string,
    name: string,
  }),
  itemClick: func,
  isSelected: bool,
  isHeaderMenu: bool,
};

export { MenuItem };
